namespace ui
{
	export namespace table
	{
		export namespace model
		{
			export class DefaultTableModelReader
				extends ui.table.DataReader<string[]>
			{

				public constructor()
				{
					super();
				}

				public GenerateDataField( p_Data: string[] ): JQuery
				{
					const row: JQuery<HTMLElement> = $( document.createElement( 'tr' ) );

					p_Data.forEach(
						( value ) =>
						{
							row.append( $( document.createElement( 'td' ) ).append( ui.$$.text( value ) ) );
						}
					);

					return row;
				}

				public AddCell( row: number, col: number, data: string ): void
				{
					this.m_Data[ row ][ col ] =  data;
				}

				public InsertCell( row: number, col: number, data: string ): void
				{
					this.m_Data[ row ].splice( col, 0, data );
				}
			}
		}
	}
}
